import styled from 'styled-components';

import wallet from '../../assets/icons/wallet/copy.svg';
import { copyLink } from 'helpers/helpers';

const WalletWrapper = styled.div`
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;

  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.white};
  border-radius: 8px;
  padding: 0 16px;
  background: radial-gradient(
      158.48% 294.91% at 50% 320.96%,
      rgba(255, 0, 122, 0.2) 0%,
      rgba(255, 0, 122, 0) 100%
    ),
    linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1));

  border: 1px solid ${({ theme }) => theme.gray}4c;
`;

export const WalletComponent = (props: any) => {
  return (
    <WalletWrapper
      onClick={() => {
        copyLink(props.value, 'The wallet has been copied');
      }}
      style={{ cursor: 'pointer' }}
    >
      <div className='truncated'>
        <div>{props.value}</div>
      </div>

      <img src={wallet} alt='withdraw' style={{ width: 80, marginLeft: 10 }} />
    </WalletWrapper>
  );
};
